import React from "react";
import OverlayRoot from "./OverlayRoot";

interface AbortUploadsModalProps {
  isOpen: boolean;
  activeCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

const AbortUploadsModal: React.FC<AbortUploadsModalProps> = ({ isOpen, activeCount, onClose, onConfirm }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <OverlayRoot
      data-section="abort-uploads-modal-root"
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[70] flex items-center justify-center p-4 overscroll-none"
      onClick={handleBackdropClick}
    >
      <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 max-w-md w-full mx-4 border border-white/20 shadow-2xl">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-red-500/20 rounded-2xl flex items-center justify-center">
            <svg className="w-6 h-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-white">Abort uploads</h3>
        </div>

        <div className="mb-8">
          <p className="text-gray-300 text-lg leading-relaxed mb-4">
            Stop{" "}
            <span className="font-semibold text-white">
              {activeCount} remaining upload{activeCount !== 1 ? "s" : ""}
            </span>
            ?
          </p>
          <p className="text-gray-400 text-sm">
            Files already uploaded stay in the album. You can resume the rest from this window.
          </p>
        </div>

        <div className="flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 text-white bg-gray-600/50 hover:bg-gray-600/70 rounded-2xl font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gray-500/50"
          >
            Keep uploading
          </button>
          <button
            onClick={onConfirm}
            disabled={activeCount === 0}
            className="flex-1 px-6 py-3 text-white bg-red-500 hover:bg-red-600 rounded-2xl font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-red-500/50"
          >
            Abort
          </button>
        </div>
      </div>
    </OverlayRoot>
  );
};

export default AbortUploadsModal;
